import { GalleryFiltersAndSorting } from '@app/entities/images/interfaces/gallery-filters-and-sorting';
import { ContentTypeFilterValues } from '@app/pages/gallery/content-type-filter/content-type-filter-values';
import { OrientationFilterValues } from '@app/pages/gallery/orientation-filter/orientation-filter-values';
import { PricingFilterValues } from '@app/pages/gallery/pricing-filter/pricing-filter-values';
import { SortingOptionsValues } from '@app/pages/gallery/sorting-options/sorting-options-values';

export class LoadGallery {
  static readonly type = '[Gallery] Load gallery';
  constructor(public preserveResults: boolean = false) {}
}

export class ResetGalleryFilters {
  static readonly type = '[Gallery] Reset gallery filters';
  constructor() {}
}

export class ResetGallerySecondaryFilters {
  static readonly type = '[Gallery] Reset gallery secondary filters';
  constructor() {}
}

export class SetGalleryCategory {
  static readonly type = '[Gallery] Set category';
  constructor(public value?: string) {}
}

export class SetSearchRequestValue {
  static readonly type = '[Gallery] Set search request value';
  constructor(public value: string) {}
}

export class SetPricingFilterValue {
  static readonly type = '[Gallery] Set pricing filter value';
  constructor(public value: PricingFilterValues) {}
}

export class SetContentTypeFilterValue {
  static readonly type = '[Gallery] Set content type filter value';
  constructor(public value: string) {}
}

export class ToggleContentTypeFilterValue {
  static readonly type = '[Gallery] Toggle content type filter value';
  constructor(public value: ContentTypeFilterValues) {}
}

export class SetOrientationFilterValue {
  static readonly type = '[Gallery] Set orientation filter value';
  constructor(public value: OrientationFilterValues) {}
}

export class SetSortingOptionsValue {
  static readonly type = '[Gallery] Set sorting options value';
  constructor(public value: SortingOptionsValues) {}
}

export class PopulateFilters {
  static readonly type = '[Gallery] Populate filters';
  constructor(public data: GalleryFiltersAndSorting) {}
}
